/**
 * O que já foi encaminhado ao suporte nesta aba.
 *
 * A conversa volta do Redis num F5 com a oferta no envelope, e o botão
 * reapareceria sobre um encaminhamento que já aconteceu. A chave é a conversa
 * mais o resumo DO WIRE — imutável por turno —, não o id da bolha, que
 * nasce de novo a cada reidratação. Mesmo padrão de `rascunhoDaAcao.ts`.
 */

export const CHAVE_DOS_ENCAMINHAMENTOS = 'assistentePontotel:suporteEncaminhado:v1'

function armazenamento (): Storage | null {
  try { return typeof sessionStorage === 'undefined' ? null : sessionStorage } catch { return null }
}

function chave (sessaoId: string, resumo: string): string {
  return `${sessaoId}\n${resumo}`
}

function lerRegistro (): Record<string, string> {
  try {
    const texto = armazenamento()?.getItem(CHAVE_DOS_ENCAMINHAMENTOS)
    const lido = texto ? JSON.parse(texto) as unknown : {}
    return lido && typeof lido === 'object' && !Array.isArray(lido) ? lido as Record<string, string> : {}
  } catch {
    return {}
  }
}

export function encaminhadaEm (sessaoId: string, resumo: string): string | null {
  return lerRegistro()[chave(sessaoId, resumo)] ?? null
}

export function registrarEncaminhamento (sessaoId: string, resumo: string, momento: string): void {
  try {
    const registro = lerRegistro()
    registro[chave(sessaoId, resumo)] = momento
    armazenamento()?.setItem(CHAVE_DOS_ENCAMINHAMENTOS, JSON.stringify(registro))
  } catch {
    // Sem storage o botão volta depois de um F5; o encaminhamento já aconteceu.
  }
}
